import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from './Appbar'
import Helmet from 'react-helmet';
import {
    Avatar, Badge, Box, Button, CircularProgress, Container, Dialog, DialogActions,
    DialogContentText, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select,
    Tab, Tabs, TextField, Tooltip, Typography, withStyles
} from '@material-ui/core';
import { Catagories } from '../util/HardCodedLists';
import ImageUploader from './ImageUploader';
import ChipInput from './chipInput';
import ReactHookFormSelect from './ReactHookFormSelect';
import { Controller } from 'react-hook-form';
import { ModelBundle } from '../types/List';
import RTE from './RTE';
import SimpleConfirm from './SimpleConfirm';
import { red } from '@material-ui/core/colors';
import { deleteAll } from '../util/listFunctions';
import debounce from '../util/BootDash/Debounce';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

type propTypes = {
    errors: any;
    register: any;
    control: any;
    enqueueSnackbar: any;
    list: ModelBundle;
    visible: boolean;
    history: any;
}

export default function (props: propTypes) {
    const [images, setimages] = useState(props.list.Images);
    const { errors, register, enqueueSnackbar } = props;

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deleteListDialog, setdeleteListDialog] = useState(false);

    function UpdateImageOrder(newImages: any[]) {
        axios.post(`/api/list/${props.list.PublicID}/images`,
            { images: newImages.map((i: any) => i.url.split('/').slice(-2).join('/')) });
    }
    const debouncedUpdate = AwesomeDebouncePromise(UpdateImageOrder, 3000);

    function deleteListReq() {
        axios.delete(`/api/list/${props.list.PublicID}`, { withCredentials: true });
    }

    function deleteList() {
        axios.delete(`/api/list/${props.list.PublicID}`, { withCredentials: true }).then(() => {
            props.history.push({
                pathname: '/',
                state: { message: 'Your list was yeeted into outer space' }
            })
        });
    }

    const ColorButton = withStyles((theme: Theme) => ({
        root: {
            color: theme.palette.getContrastText(red[500]),
            backgroundColor: red[500],
            '&:hover': {
                backgroundColor: red[700],
            },
        },
    }))(Button);

    return (
        <div className={`max-w-xl mx-auto ${props.visible ? '' : 'hidden'}`}>
            <div className='flex flex-col gap-10 mt-10'>
                <div className="flex flex-col gap-3">
                    <Typography variant="h6">Title</Typography>
                    <TextField
                        name="Name"
                        error={errors.Name !== undefined}
                        helperText={errors.Name?.message}
                        fullWidth
                        defaultValue={props.list.Name}
                        variant="outlined"
                        inputRef={register({ required: 'Required', minLength: { value: 3, message: 'Title must be at least 3 characters' } })}
                    />
                </div>
                <div>
                    <Typography variant="h6">Description</Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2">
                        Talk a bit about what's in your bundle and any other details users might need to know. Maybe something like:
                    </Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2 italic">
                        "This bundle includes [model count] models including [things in your bundle]. All in FBX and GLB formats, free to use in personal and commercial projects. Check out my [website/patreon/twitter]!"
                    </Typography>
                    <RTE
                        control={props.control}
                        name={"Description"}
                        defaultValue={props.list.Description}
                    />
                    {/* <TextField
                        variant="outlined"
                        fullWidth
                        multiline
                        minRows={6}
                        maxRows={12}
                        name="Description"
                        error={errors.Description !== undefined}
                        defaultValue={props.list.Description}
                        helperText={errors.Description?.message}
                        inputRef={register({ required: 'Required', minLength: { value: 10, message: 'Description must be at least 10 characters' } })}
                    /> */}
                </div>
                <div>
                    <Typography variant="h6">Category</Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2">Select the category that best describes your bundle. You can pick additional terms with tags below</Typography>
                    <ReactHookFormSelect
                        name="Category"
                        label="Category"
                        control={props.control}
                        defaultValue={props.list.Category}
                        id="catInput"
                        fullWidth
                        error={errors.Category !== undefined}
                    >
                        {Catagories.map((item, index) => {
                            if (item === 'Other') index = 999;
                            return <MenuItem key={index} value={index}>{item}</MenuItem>
                        })}
                    </ReactHookFormSelect>
                </div>

                <div>
                    <Typography variant="h6">Images</Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2">Optional but highly recommended. Add any images that you want to show along side your bundle. Renders or Screenshots of all the models work great for this. Drag images to reorder.</Typography>
                    <ImageUploader
                        imageURLs={images}
                        max={5}
                        uploadEndpoint={`/api/list/${props.list.PublicID}/images/upload`}
                        uploadField={'images'}
                        onReorder={(newImages: any) => {
                            //Get image urls and remove "https://static.poly.pizza"
                            debouncedUpdate(newImages);
                        }}
                        removeImage={(url: string) => {
                            const split = url.split('/');
                            const image = `${split[split.length - 2]}/${split[split.length - 1]}`;
                            console.log(image);
                            axios.delete(`/api/list/${props.list.PublicID}/images/${encodeURIComponent(image)}`)
                        }}
                    />
                </div>

                <div>
                    <Typography variant="h6">Tags</Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2">Add any additional terms that describe your bundle. Press enter to add a tag, max 8. Tags may be edited by a moderator</Typography>

                    {/* <ChipInput
                        enqueueSnackbar={enqueueSnackbar}
                        maxTagLength={20}
                        chipData={chipData}
                        setChipData={setChipData}
                    /> */}
                    <Controller
                        control={props.control}
                        name="Tags"
                        defaultValue={props.list.Tags.map((t) => { return { key: Math.random(), label: t } }) ?? []}
                        render={(props) => (
                            <ChipInput
                                enqueueSnackbar={enqueueSnackbar}
                                maxTagLength={20}
                                chipData={props.value}
                                setChipData={(e) => { console.log(e); props.onChange(e) }}
                            />
                        )}
                    />

                </div>

                <div className='w-full'>
                    <Typography variant="h6">Visibility</Typography>
                    <Typography variant="body1" color="textSecondary" className="!my-2">When you're ready to publish, set this to public!</Typography>
                    <ReactHookFormSelect
                        name="Visibility"
                        label="Visibility"
                        control={props.control}
                        placeholder="Visibility"
                        fullWidth
                        error={errors.Visibility !== undefined}
                        defaultValue={props.list.Visibility || 0}>
                        <MenuItem value={'Unlisted'}>Unlisted</MenuItem>
                        <MenuItem value={'Public'}>Public</MenuItem>
                    </ReactHookFormSelect>
                </div>

                <div className=" flex flex-col gap-4 mb-[10vh]">

                    <Typography variant='h6' className=''>⚠️Danger zone</Typography>
                    <ColorButton variant="outlined" onClick={() => setdeleteListDialog(true)}>Delete bundle</ColorButton>
                    <ColorButton variant="outlined" onClick={() => setConfirmOpen(true)}>Delete bundle + models</ColorButton>
                </div>
            </div>

            <SimpleConfirm
                setOpen={setdeleteListDialog}
                open={deleteListDialog}
                action={deleteList}
                title="Delete List?"
                content="Do you want to delete this list? Models won't be deleted. You can't undo this."
            />

            <SimpleConfirm
                setOpen={setConfirmOpen}
                open={confirmOpen}
                action={() => { deleteListReq(); deleteAll(props.list.Models, props.history, enqueueSnackbar); }}
                title="⚠️ Delete all models? ⚠️"
                content="This won't just delete the list but will delete all your models from the site permanently. You can't undo this. Are you sure?"
            />
        </div>
    );
}
